<div class="station-details">
  <sc-padding [fitHeight]="true">
    <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true" *ngIf="station != null">
      <sc-flex-fitting-content [vertical]="true">
        <sc-loading-spinner [isLoading]="isLoading" [fitHeight]="true">

          <ng-container *ngIf="stationDetailsView === stationDetailsViewValues.STATION_DISABLED">
            <sc-padding [double]="true">
              {{'Bearbeitung ist momentan nicht möglich!' | translate:
              ['tmc-yard.action-tablet.station-transport-details.station-disabled', translationService.language,
              [station?.stationUsage?.note]]}}
            </sc-padding>
            <sc-flex [stretchContent]="true">
              <sc-content-spacer [grow]="true"></sc-content-spacer>
              <sc-icon iconClass="fa-lock-open" (click)="endSuspension()"
                *ngIf="station.stationUsage.suspended"></sc-icon>
            </sc-flex>
          </ng-container>

          <ng-container *ngIf="stationDetailsView !== stationDetailsViewValues.STATION_DISABLED">
            <!-- <ng-container *ngIf="showTransportDetails"> -->
            <div class="transport-details" [ngClass]="{'ongoing-movement': station.stationUsage.ongoingMovementFromStation || station.stationUsage.ongoingMovementToStation}">
              <sc-flex [vertical]="true" [fitHeight]="true" [stretchContent]="true" >
                <div class="header" *ngIf="showHeader">
                   <!-- BEGIN: HEADER -->
                   <div *ngIf="stationDetailsView === stationDetailsViewValues.ONGOING_MOVEMENT_ORDER_TO_STATION">
                    <sc-padding>
                      <div class="title">
                        <sc-icon iconClass="fa-truck-flatbed"></sc-icon>
                        {{'Laufender Rangierauftrag' | translate:
                        ['tmc-yard.action-tablet.station-transport-details.ongoingMovement',
                        translationService.language]}}
                      </div>
                    </sc-padding>
                    <sc-content-spacer [double]="true" [vertical]="true"></sc-content-spacer>
                  </div>

                  <div *ngIf="stationDetailsView === stationDetailsViewValues.ONGOING_MOVEMENT_ORDER_FROM_STATION">
                    <div class="title">
                      <sc-flex stretchContent centered>
                        <app-transport-scope-icon [scope]="transportDetails?.scope"></app-transport-scope-icon>
                        <sc-content-spacer></sc-content-spacer>
                        <ng-container *ngIf="transportDetails?.scope === 'SWAP_TRAILER'">
                          {{'Wechselbrücke angestellt - Laufender Rangierauftrag' | translate:
                          ['tmc-yard.action-tablet.station-transport-details.occupied-ongoingMovement-swaptrailer',
                          translationService.language]}}
                        </ng-container>
                        <ng-container *ngIf="transportDetails?.scope === 'TRAILER'">
                          {{'Trailer angestellt - Laufender Rangierauftrag' | translate:
                          ['tmc-yard.action-tablet.station-transport-details.occupied-ongoingMovement-trailer',
                          translationService.language]}}
                        </ng-container>
                        <ng-container
                          *ngIf="transportDetails?.scope === 'TRAIN' || transportDetails?.scope === 'SEMI_TRAILER_TRUCK'">
                          {{'Zug angestellt - Laufender Rangierauftrag' | translate:
                          ['tmc-yard.action-tablet.station-transport-details.occupied-ongoingMovement-others',
                          translationService.language]}}
                        </ng-container>

                      </sc-flex>
                    </div>
                    <sc-content-spacer [double]="true" [vertical]="true"></sc-content-spacer>
                  </div>

                  <div *ngIf="stationDetailsView === stationDetailsViewValues.STATION_OCCUPIED">
                    <div class="title occupied">
                      <sc-flex  stretchContent centered>
                        <app-transport-scope-icon [scope]="transportDetails?.scope"></app-transport-scope-icon>
                        <ng-container *ngIf="transportDetails?.scope === 'SWAP_TRAILER'">
                          {{'Wechselbrücke angestellt' | translate:
                          ['tmc-yard.action-tablet.station-transport-details.occupied-ongoingMovement-swaptrailer',
                          translationService.language]}}
                        </ng-container>
                        <ng-container *ngIf="transportDetails?.scope === 'TRAILER'">
                          {{'Trailer angestellt' | translate:
                          ['tmc-yard.action-tablet.station-transport-details.occupied-ongoingMovement-trailer',
                          translationService.language]}}
                        </ng-container>
                        <ng-container
                          *ngIf="transportDetails?.scope === 'TRAIN' || transportDetails?.scope === 'SEMI_TRAILER_TRUCK'">
                          {{'Zug angestellt' | translate:
                          ['tmc-yard.action-tablet.station-transport-details.occupied-ongoingMovement-others',
                          translationService.language]}}
                        </ng-container>
                      </sc-flex>
                    </div>
                    <sc-content-spacer [double]="true" [vertical]="true"></sc-content-spacer>
                  </div>
                  <!-- END: HEADER -->
                </div>
                <sc-flex-fitting-content [vertical]="true">
                  <div class="transport-details-container">
                    <sc-scroll-pane>

                      <ng-container *ngIf="showTransportDetails">
                        <sc-padding>
                          <app-transport-details [mode]="TransportDetailMode.READONLY" [layout]="layoutDefinition"
                            [transport]="transportDetails">
                          </app-transport-details>
                        </sc-padding>
                      </ng-container>

                      <div *ngIf="!showTransportDetails">
                        
                        <sc-tab-group #transportCreationProfilesTabGroup *ngIf="station?.stationUsage.transportCreationProfileGroups.length > 1">
                          <sc-tab *ngFor="let group of station?.stationUsage.transportCreationProfileGroups, let i = index" [title]="group.displayName" [data]="group" [active]="i===0">
                            <div>
                              <app-service-response [responseMessages]="responseMessages"></app-service-response>
                              <sc-flex [wrap]="true">
                                <app-action-tablet-transport-creation-profile-details 
                                  (transportCreationProfileSelected)="createPlannedTransportFromProfile(reference)"
                                  [transportCreationProfile]="reference" 
                                  *ngFor="let reference of group.transportCreationProfiles"></app-action-tablet-transport-creation-profile-details>
                                </sc-flex>
                            </div>
                          </sc-tab>
                        </sc-tab-group>
                        <ng-container *ngIf="station?.stationUsage.transportCreationProfileGroups.length === 1">
                          <app-service-response [responseMessages]="responseMessages"></app-service-response>
                          <app-action-tablet-transport-creation-profile-details 
                                (transportCreationProfileSelected)="createPlannedTransportFromProfile(reference)"
                                [transportCreationProfile]="reference"
                                *ngFor="let reference of station?.stationUsage.transportCreationProfileGroups[0].transportCreationProfiles"></app-action-tablet-transport-creation-profile-details>
                        </ng-container>
                      </div>

                    </sc-scroll-pane>
                  </div>
                </sc-flex-fitting-content>

                <div>
                  <sc-content-spacer [vertical]="true"></sc-content-spacer>
                  <app-action-tablet-buttonbar [station]="station" [transportDetails]="transportDetails"
                    [defaultCompletionOption]="defaultCompletionOption"></app-action-tablet-buttonbar>
                </div>
              </sc-flex>
            </div>
        
          </ng-container>
        </sc-loading-spinner>
      </sc-flex-fitting-content>
    </sc-flex>
  </sc-padding>